import React from "react";
import classes from "./LayoutFooter.module.scss";
import { useRecoilValue } from "recoil";
import { zoomState } from "../../states/zoomState";
const LayoutFooter = () => {
  const zoomLevel = useRecoilValue(zoomState);
  return (
    <footer>
      <ul
        className={classes.footerRoot}
        style={{
          width: `${100 / Number(zoomLevel)}vw`, // 親コンテナの幅を調整
        }}
      >
        <a
          className={classes.text}
          href="https://www.morimatsu.jp/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <li>運営会社</li>
        </a>
        <a className={classes.text} href="/" rel="noreferrer noopener">
          <li>利用規約</li>
        </a>
        <a className={classes.text} href="/" rel="noreferrer noopener">
          <li>プライバシーポリシー</li>
        </a>
        <a className={classes.text}>
          <li>Copyright &copy; 2024 MORIMATSU INDUSTRY CO.,LTD</li>
        </a>
      </ul>
    </footer>
  );
};

export default LayoutFooter;
